import SecondFactorStep from 'components/organisms/RegistrationForm/SecondFactorStep';
import React from 'react';

export interface Props {
  sessionId: string;
  username: string;
}

const SecondFactor: React.FC<Props> = (props) => {
  return <SecondFactorStep {...props} />;
};
export default SecondFactor;
